import { useState } from "react";
import { useSelector } from "react-redux";
import editIcon from "../../../../images/icons/edit.svg";
import trashIcon from "../../../../images/icons/delete.svg";
import DeleteModal from "../../../common/DeleteModal";
import CourtsService from "../../../../services/CourtsService";

const CardItem = ({ item, setAddModal, index, setItem, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);
	const courtsService = new CourtsService();

	return (
		<tr key={index} className="text-center">
			<td>{item[`name_${lang}`] || "-"}</td>
			<td>
				{item?.location?.startsWith("http") ? (
					<a href={item?.location} target="_blank" rel="noreferrer">
						<i className="fa fa-map" />
					</a>
				) : (
					"-"
				)}
			</td>
			<td>{item?.location}</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{isExist("update_courts") && (
						<img
							src={editIcon}
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}
							className="cursor-pointer"
							alt="edit"
							width={24}
						/>
					)}
					{isExist("delete_courts") && (
						<img
							src={trashIcon}
							onClick={() => setDeleteModal(true)}
							className="cursor-pointer"
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item[`name_${lang}`]}
					deletedItem={item}
					modelService={courtsService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
